import React from 'react'
import PropTypes from 'prop-types'
import { TransitionOverlay } from './TransitionOverlay'
import { ITEM_SOURCES } from 'shared/constants'
import { ITEM_POSITIONS } from '../constants'
import { ThemeColorContext } from '../context'
import ItemRenderer from './ItemRenderer'

import './style.css.scss'

const ITEM_SOURCE_VIEW_CLASS = {
  [ITEM_SOURCES.link]: 'item-limited-width',
  [ITEM_SOURCES.file]: 'item-limited-width',
  [ITEM_SOURCES.box]: 'item-limited-width',
  [ITEM_SOURCES.article]: 'item-full-width',
}

class ItemContent extends React.Component {
  _isMounted = false

  constructor(props) {
    super(props)
    this.state = {
      isInTransitionWindow: true,
      isCurrent: props.itemPosition == ITEM_POSITIONS.current
    }
  }

  componentDidMount() {
    this._isMounted = true
    this.state.isCurrent && this.animateTransition()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isCurrent != this.state.isCurrent) {
      if (this.state.isCurrent && this._isMounted) {
        this.animateTransition()
      }
      else {
        this.setState({ isInTransitionWindow: true })
      }
    }
    if (prevProps.itemPosition != this.props.itemPosition) {
      this.setState({
        isCurrent: this.props.itemPosition == ITEM_POSITIONS.current
      })
    }
  }

  animateTransition = () => {
    setTimeout(() => {
      this.setState({ isInTransitionWindow: false })
    }, 1000)
  }

  render() {
    const itemSourceViewClass = ITEM_SOURCE_VIEW_CLASS[this.props.item.item_source]
    const videoItemClass = !!this.props.isVideoItem ? 'video-content' : ""

    return (
      <div className={`item-content-wrapper
                    ${this.props.itemPosition}-item
                    ${itemSourceViewClass}
                    ${videoItemClass}`}>
        <div className="item-content">
          <div className="content">
            { this.state.isCurrent &&
              <ThemeColorContext.Provider value={this.props.themeColorHex}>
                <ItemRenderer
                  item={this.props.item}
                  requireSsl={this.props.requireSsl}
                  contentItemId={this.props.contentItemId}
                  onClick={this.props.onClick}
                  onItemContentAction={this.props.onItemContentAction} />
              </ThemeColorContext.Provider>
            }
            <TransitionOverlay isReady={!this.state.isInTransitionWindow} />
          </div>
        </div>
      </div>
    )
  }
}

ItemContent.propTypes = {
  item: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  contentItemId: PropTypes.number.isRequired,
  itemPosition: PropTypes.string,
  onClick: PropTypes.func,
  requireSsl: PropTypes.bool,
  isVideoItem: PropTypes.bool
}

ItemContent.defaultProps = {
  itemPosition: ITEM_POSITIONS.current
}

export default ItemContent